import { render, staticRenderFns } from "./producto_datos_basicos.vue?vue&type=template&id=631564b4&scoped=true"
import script from "./producto_datos_basicos.vue?vue&type=script&lang=js"
export * from "./producto_datos_basicos.vue?vue&type=script&lang=js"
import style0 from "./producto_datos_basicos.vue?vue&type=style&index=0&id=631564b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631564b4",
  null
  
)

export default component.exports